<app-gallery-related-office [relatedOffice]="relatedOffice" *ngIf="relatedOffice"></app-gallery-related-office>
<div class="top-info is-flex has-flex-align-center has-flex-content-space-between" *ngIf="(selectedClusterListings.length > 0 || items.length > 0)">
  <span class="has-pos-rel listings-count">
    {{ isFavouritesPage ? ('gallery.saved-listings-count' | translate : {pageCount: selectedClusterListings.length}) : ('gallery.listings-count' | translate : {pageCount: totalResultsFound}) }}
  </span>
  <form [formGroup]="sortForm">
    <app-select [options]="sortOptions" [formControl]="sortForm.get('sort')" [parentFormGroup]="sortForm"></app-select>
  </form>
</div>
<div class="gallery-container full-width"
  infiniteScroll
  [infiniteScrollDistance]="2"
  [infiniteScrollThrottle]="500"
  [scrollWindow]="true"
  (scrolled)="getMoreListings();onInfiniteScroll()"
>
  <div class="gallery-list is-flex has-flex-wrap">
    <app-listing-card
        *ngFor="let listing of selectedClusterListings; trackBy: Listing.trackBy"
        [isSelectedCard]="true"
        [confirmUnfavourite]="true"
        [listing]="listing"
        (click)="onGalleryCardClicked(listing)"
        >
    </app-listing-card>
    <div *ngIf="selectedClusterListings.length > 0 && items.length > 0"
      class="more-listings-separator text-center visible-xs full-width" style="margin: 20px 0;" [translate]>gallery.more-listings</div>

    <app-listing-card
      *ngFor="let listing of items; trackBy: Listing.trackBy"
      [listing]="listing"
      [isSelectedCard]="true"
      [confirmUnfavourite]="confirmUnfavourite"
      (click)="onGalleryCardClicked(listing)"
      >
    </app-listing-card>
    <app-panel-message *ngIf="isDoneFetchingAllItems && (selectedClusterListings.length === 0 && items.length === 0)">
      <h4 translate="panel-message.no-results"></h4>
      <p translate="panel-message.broaden-search"></p>
    </app-panel-message>
  </div>
  <!-- We include this for mobile for SEO purposes but we dont show this to the user -->
  <app-pagination class="hide-on-mobile" [totalPages]="pagination.totalPages" [currentPageNumber]="pagination.pageNumber" (onChangePage)="changePage.emit($event)"></app-pagination>
</div>

<app-loader [isLoading]="!isDoneFetchingAllItems"></app-loader>
<app-logo></app-logo>
<ng-content></ng-content>
